import { put, takeLatest, call, all } from "redux-saga/effects";
import axios from "axios";
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  CC_ESTIMATE_SAVE_REQUEST,
  CC_ESTIMATE_SAVE_SUCCESS,
  CC_ESTIMATE_SAVE_FAILED,
  CC_ESTIMATE_LOAD_REQUEST,
  CC_ESTIMATE_LOAD_SUCCESS,
  CC_ESTIMATE_LOAD_FAILED,
} from "../../../_utils/constants/CountertopCabinetEstimate";

// Persist a Countertops/Cabinets manual estimate. The payload's `estimateId` decides create vs
// update (0 = create, >0 = update) so re-saving never duplicates. Reuses the existing
// axios-in-saga + Bearer auth + 401 -> SESSION_EXPIRED convention.
export function* saveCountertopCabinetEstimate({ token, payload }) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Ordering/api/Order/SaveCountertopCabinetEstimate`,
      payload,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    yield put({ type: CC_ESTIMATE_SAVE_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: CC_ESTIMATE_SAVE_FAILED, payload: error?.response });
    }
  }
}

// Load a saved estimate for a customer + floor plan (+ optional variant).
export function* loadCountertopCabinetEstimate({ token, contactInfoId, unitTypeId, variantId = 0 }) {
  try {
    const response = yield call(
      axios.get,
      `${API_URL}/Ordering/api/Order/GetCountertopCabinetEstimate?ContactInfoId=${contactInfoId}&UnitTypeId=${unitTypeId}&VariantId=${variantId || 0}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    yield put({ type: CC_ESTIMATE_LOAD_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: CC_ESTIMATE_LOAD_FAILED, payload: error?.response });
    }
  }
}

export default function* rootCountertopCabinetEstimate() {
  yield all([
    takeLatest(CC_ESTIMATE_SAVE_REQUEST, saveCountertopCabinetEstimate),
    takeLatest(CC_ESTIMATE_LOAD_REQUEST, loadCountertopCabinetEstimate),
  ]);
}
